<script>
  import { apiFetch } from "../lib/api.js";
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import CardContent from "../components/CardContent.svelte"
  import Navbar from "../components/Navbar.svelte"
  import Spinner from "../components/Spinner.svelte"
  import { user } from "../stores/user"
  import { BASE_URL } from "../stores/BASE_URL"
  import Alert from "../components/Alert.svelte"
  import getFecha from "../services/fecha"
  import { formatMoneda } from "../services/formatMoneda"

  let clientes = []
  let select_cliente = ""
  let cliente = undefined
  let isLoading = false

  let isLoadingRenovarContrato = false

  let acciones = false

  let alert = {
    show: false,
    message: "",
    status: "",
    time: 3000,
  }

  let fecha = getFecha()

  const getClientes = async () => {
    const response = await apiFetch(`${BASE_URL}cliente.php?action=getClientes`)
    const resp = await response.json()
    clientes = resp.data
  }

  const getCliente = async () => {
    isLoading = true
    const s_cliente = clienteByRazonSocial(select_cliente)
    if (!s_cliente) {
      window.alert("Seleccionar cliente")
      isLoading = false
      return
    }

    const response = await apiFetch(
      `${BASE_URL}cliente.php?action=getClienteDetallado&id_cliente=${s_cliente.id}`,
    )
    const resp = await response.json()
    cliente = resp.data
    isLoading = false

    console.log(cliente)
  }

  const clienteByRazonSocial = (razon_social) => {
    let s_cliente = clientes.find((c) => c.razon_social === razon_social)
    if (s_cliente) {
      return s_cliente
    } else {
      return undefined
    }
  }

  const renovarContrato = async (id_cliente, id_operacion, inicio, fin) => {
    isLoadingRenovarContrato = true
    const formData = new FormData()
    formData.append("id_cliente", id_cliente)
    formData.append("id_operacion", id_operacion)
    formData.append("inicio", inicio)
    formData.append("fin", fin)
    formData.append("action", "renovarContrato")
    formData.append("session_id_usuario", $user.idUsuario)

    const response = await apiFetch(`${BASE_URL}cliente.php`, {
      method: "POST",
      body: formData,
    })

    const resp = await response.json()
    if (resp.status == "success") {
      window.alert(resp.message)
    } else {
      window.alert(resp.message)
    }
    isLoadingRenovarContrato = false
    getCliente()
  }

  getClientes()

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    }

    if ($user.rol == "administrador" || $user.rol == "operaciones") {
      acciones = true
    }
  })
</script>

{#if $user}
  <Navbar />
  <div class="container-fluid py-3">
    <CardContent title="Clientes">
      <div class="row g-2 align-items-center">
        <div class="col-12 col-sm-12 col-md-6 col-lg-4">
          <input
            list="list_clientes"
            bind:value={select_cliente}
            class="form-control"
            placeholder="Cliente"
          />
          <datalist id="list_clientes">
            {#each clientes as cliente}
              <option value={cliente.razon_social} />
            {/each}
          </datalist>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-auto">
          {#if isLoading}
            <button class="btn btn-primary" type="button" disabled>
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              Cargando...
            </button>
          {:else}
            <button class="btn btn-primary" on:click={getCliente}>
              Ver cliente
            </button>
          {/if}
        </div>
      </div>

      {#if alert.show}
        <Alert
          message={alert.message}
          status={alert.status}
          time={alert.time}
        />
      {/if}

      {#if isLoading}
        <Spinner message="Cargando" />
      {:else if !cliente}
        <p class="text-center text-secondary">
          · · · Seleccionar un cliente · · ·
        </p>
      {:else}
        <div class="row">
          <div class="col-12 col-lg-6 mt-4">
            <h5>Datos del cliente:</h5>

            <div class="table-responsive">
              <table class="table table-sm table-striped table-bordered">
                <tbody>
                  <tr>
                    <th class="text-secondary">Razón Social / Nombre</th>
                    <td>{cliente.razon_social}</td>
                  </tr>

                  <tr>
                    <th class="text-secondary">Número de documento</th>
                    <td>{cliente.documento}</td>
                  </tr>

                  <tr>
                    <th class="text-secondary">Usuarios</th>
                    <td>
                      <small
                        class="d-inline-flex px-2 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2"
                      >
                        Activos: {cliente.usuarios.activos}
                      </small>
                      <small
                        class="d-inline-flex px-2 fw-semibold text-danger bg-danger bg-opacity-10 border border-danger border-opacity-10 rounded-2"
                      >
                        Suspendidos: {cliente.usuarios.suspendidos}
                      </small>
                      <small
                        class="d-inline-flex px-2 fw-semibold text-dark bg-dark bg-opacity-10 border border-dark border-opacity-10 rounded-2"
                      >
                        De baja: {cliente.usuarios.de_baja}
                      </small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 col-lg-6 mt-4">
            <h5>Contratos:</h5>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-bordered">
                <thead>
                  <tr class="text-secondary fw-normal">
                    <th>Id operación</th>
                    <th>Inicio</th>
                    <th>Fin</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {#each cliente.contratos as contrato}
                    <tr>
                      <td>{contrato.id_operacion}</td>
                      <td>{contrato.inicio}</td>
                      <td>{contrato.fin}</td>
                      <td>
                        {#if fecha >= contrato.inicio && fecha <= contrato.fin}
                          {#if isLoadingRenovarContrato}
                            <button
                              class="btn btn-sm btn-primary py-0"
                              type="button"
                              disabled
                            >
                              <span
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              />
                              Cargando...
                            </button>
                          {:else}
                            <button
                              class="btn btn-sm btn-primary py-0"
                              on:click={() =>
                                renovarContrato(
                                  contrato.id_cliente,
                                  contrato.id_operacion,
                                  contrato.inicio,
                                  contrato.fin,
                                )}
                            >
                              <i class="bi bi-arrow-clockwise"></i> Renovar Contrato
                            </button>
                          {/if}
                        {/if}
                      </td>
                    </tr>
                  {:else}
                    <tr>
                      <td class="text-center text-secondary" colspan="4"
                        >· · · No se encontraron resultados · · ·</td
                      >
                    </tr>
                  {/each}
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-12 mt-4">
            <h5>Comprobantes (Últimos 6 meses):</h5>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-bordered">
                <thead>
                  <tr class="text-secondary fw-normal">
                    <th>VDP</th>
                    <th>Id operación</th>
                    <th>Tipo de comprobante</th>
                    <th>Serie</th>
                    <th>Número de comprobante</th>
                    <th class="text-end">Sub-Total</th>
                    <th class="text-end">IGV</th>
                    <th class="text-end">Total</th>
                    <th class="text-end">Detracción</th>
                    <th class="text-end">Total a pagar</th>
                    <th>Fecha factura</th>
                    <th>Fecha vencimiento</th>
                    <th>Estado</th>
                    <th>Obs</th>
                  </tr>
                </thead>
                <tbody>
                  {#each cliente.comprobantes as comprobante}
                    <tr>
                      <td>{comprobante.vdp}</td>
                      <td>{comprobante.id_operacion}</td>
                      <td>{comprobante.tipo_comprobante}</td>
                      <td>{comprobante.serie}</td>
                      <td>{comprobante.num_comprobante}</td>
                      <td class="text-end"
                        >{formatMoneda(comprobante.subtotal)}</td
                      >
                      <td class="text-end">{formatMoneda(comprobante.igv)}</td>
                      <td class="text-end">{formatMoneda(comprobante.total)}</td
                      >
                      <td class="text-end"
                        >{formatMoneda(comprobante.montoDetraccion)}</td
                      >
                      <td class="text-end"
                        >{formatMoneda(comprobante.totalPagar)}</td
                      >
                      <td>{comprobante.fecha_factura}</td>
                      <td>{comprobante.fecha_vencimiento}</td>
                      <td>{comprobante.estado.toUpperCase()}</td>
                      <td>{comprobante.obs}</td>
                    </tr>
                  {:else}
                    <tr>
                      <td class="text-center text-secondary" colspan="10"
                        >· · · No se encontraron resultados · · ·</td
                      >
                    </tr>
                  {/each}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      {/if}
    </CardContent>
  </div>
{/if}
